const Paper = {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none"
      }
    }
  }
}
export default Paper